"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M1 3h14c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1zm1 2v6h12V5H2z"];
//# sourceMappingURL=rectangle.js.map